// Routes.js
// @author: anghello

import React from 'react';
import { Switch, useHistory } from 'react-router-dom';
import Route from './Route';

// import SignIn from '../pages/Auth/SignIn';
import SignIn3 from '../pages/Auth/SignIn3/SignIn3';
import SignUp from '../pages/Auth/SignUp';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import Dashboard from '../pages/Dashboard/Dashboard';
import Help from '../pages/Help/Help';
import Account from '../pages/User/Account';
import CreateCampaign from '../pages/Campaigns/CreateCampaign';
import ListCampaigns from '../pages/Campaigns/ListCampaigns';
import Video from '../pages/Video/Video';
import ExportedVideos from '../pages/User/ExportedVideos';
import Overview from '../pages/Campaign/Overview';
import CreateVideo from '../pages/Campaign/CreateVideo';
import Share from '../pages/Campaign/Share';
import Manage from '../pages/Campaign/Manage';
import Analyze from '../pages/Campaign/Analyze';
import Edit from '../pages/Campaign/Edit';
import NotFound from '../pages/Errors/NotFound';

import api from '../services/api';
import { useAuth } from '../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import Strings from '../translations/Translations';

export default function Routes() {
  const history = useHistory();
  const { logout, setShowMessageNoCredits, setShowMessageAiOperationsLimit, setOpenModalSubscribe } = useAuth();

  // Error handler
  api.interceptors.response.use(
    (response) => {
      try {
        if (response && response.result === 'error' && response.errorID === 801) {
          setShowMessageNoCredits(false);
          setShowMessageAiOperationsLimit(true);
          setOpenModalSubscribe(true);
        }
      } catch (err) {
        console.error(err);
      }
      
      return response;
    },
    (error) => {
      if (error) {
        switch (error.response.status) {
          case 500:
            let message = Strings('general_error');
            if (error.response.errorText) {
              message = error.response.errorText;
            } else if (error.response.data.errorText) {
              message = error.response.errorText;
            }
            toast.error(message);
            
            logout();
            history.push('/');
            break;
          default:
            break;
        }
      }

      return Promise.reject(error);
    }
  );
  
  return (
    <Switch>
      <Route path="/" exact component={SignIn3} isAuth />
      <Route path="/signup/:role?" exact component={SignUp} isAuth />
      <Route path="/forgot-password" exact component={ForgotPassword} isAuth />
      <Route path="/dashboard" exact component={Dashboard} isPrivate />
      <Route path="/help" exact component={Help} isPrivate />
      <Route path="/account" exact component={Account} isPrivate />
      <Route path="/exported-videos" exact component={ExportedVideos} isPrivate />
      <Route path="/campaigns/create" exact component={CreateCampaign} isPrivate />
      <Route path="/campaigns" exact component={ListCampaigns} isPrivate />
      <Route path="/create-video" exact component={Video} isPrivate />

      <Route path="/campaign" exact component={Overview} isPrivate />
      <Route path="/campaign/edit" exact component={Edit} isPrivate />
      <Route path="/campaign/create-video" exact component={CreateVideo} isPrivate />
      <Route path="/campaign/share" exact component={Share} isPrivate />
      <Route path="/campaign/manage" exact component={Manage} isPrivate />
      <Route path="/campaign/analyze" exact component={Analyze} isPrivate />

      <Route component={NotFound} notFound />
    </Switch>
  );
}
